import { compose } from 'redux'
import { connect } from 'react-redux'

import { reduxForm } from 'redux-form'
import { salvar_obj } from '../../actions'

import { withRouter } from 'react-router-dom';
const mapStateToProps = (state, props) => {

    const { DinamicCustomFormsReducer } = state
    const controler = DinamicCustomFormsReducer.rLista;
    let lista = controler.lista;
    let customForm = null;
    lista.forEach(f => {
        if (f.uid === props.customFormUid) {
            customForm = f;
        }
    });

    let initialValues = props.initialValues;
    if (!initialValues && props.location && props.location.state) {

        let lista = [];
        let chaveReducer = customForm.uid;
        if (customForm.chaveSalvar) {
            chaveReducer = customForm.chaveSalvar
        }
        if (DinamicCustomFormsReducer.rListaObj[chaveReducer]) {
            lista = DinamicCustomFormsReducer.rListaObj[chaveReducer].lista;
        }

        lista.forEach(item => {
            if (item.uid === props.location.state.uidItem) {
                initialValues = item;
            }
        })

    }
    let sair = props.sair;
    if (!sair && customForm.consultaPrimeiro) {
        sair = () => props.history.push("/" + customForm.rota + "Consulta")
    }
    return {
        form: 'CustomFormCrud' + customForm.nomeForm,
        customForm, crudControl: controler.rCrudObj, initialValues,
        sair
    };
};


export default compose(
    withRouter,
    connect(mapStateToProps, { salvar: salvar_obj, }),
    reduxForm(),


);


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomFormDialog/DinamicCrudCustomForm.enhancer.js